/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBrokenHeart = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M15.836 3h-.012l-.264.006h-.011A6.23 6.23 0 0 0 12 4.317c-2.42-1.896-5.955-1.743-8.195.459a5.99 5.99 0 0 0 0 8.57L12 21.403l8.195-8.057A6.007 6.007 0 0 0 22 9.06c0-1.61-.651-3.151-1.806-4.286A6.217 6.217 0 0 0 15.836 3zm-.207 2.005L15.847 5a4.217 4.217 0 0 1 2.945 1.2A4.01 4.01 0 0 1 20 9.06a4.007 4.007 0 0 1-1.207 2.859L12 18.598 5.207 11.92a3.99 3.99 0 0 1 0-5.72c1.399-1.373 3.553-1.568 5.166-.582.22.134.43.291.627.47v2.326L12.586 10l-2 2 2.707 2.707 1.414-1.414L13.414 12l2-2L13 7.586V6.087a4.204 4.204 0 0 1 2.63-1.082z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBrokenHeart as BrokenHeart };
